'use client';
import { getFlexibleFormFieldMetadata } from './flexibleFormFieldMatching';

export const PROMO_CODE_REQUIRED_ERROR = <p>{'Enter a valid promo code'}</p>;
export type PromoCodeErrorState = 'redeemed' | 'expired' | 'invalid';

export function isPromoCodeFormField(formField: SiteFormField) {
    const { fieldName, displayName, label } = getFlexibleFormFieldMetadata(formField);

    return fieldName === 'promocode' || displayName === 'promocode' || label === 'promocode';
}

export function sanitizePromoCode(value: string) {
    return value.replace(/[^A-Za-z0-9-]/g, '');
}

export function getPromoCodeFieldErrorMessage(errorState: PromoCodeErrorState, viewOtherOffersUrl: string) {
    if (errorState === 'redeemed') {
        return (
            <p>
                {'The promo code entered has already been redeemed. '}
                <a href={viewOtherOffersUrl} target="_self">
                    {'View other offers.'}
                </a>
            </p>
        );
    }

    return (
        <p>
            {'The promo code entered is invalid. Try re-entering your promo code or continue to '}
            <a href={viewOtherOffersUrl} target="_self">
                {'View other offers.'}
            </a>
        </p>
    );
}

export function getPromoCodeFormErrorMessage(viewOtherOffersUrl: string) {
    return (
        <p>
            {'We’re unable to validate your promo code right now. Try again or continue to '}
            <a href={viewOtherOffersUrl} target="_self">
                {'View other offers.'}
            </a>
        </p>
    );
}
